import { errorToString, StatusData } from "@oneethos/shared"
import { useState } from "react"
import { toast } from "react-toastify"
import api from '../api-client'
import { Spinner } from "@fluentui/react"

type LoanNumberProps = {
  project: StatusData
  onChange: (project: StatusData) => void
}

export const LoanNumber = ({ project, onChange }: LoanNumberProps) => {
  const [loading, setLoading] = useState(false)

  return <div className="loan-number mb-4">
    <h6>Loan Number</h6>
    {project.loanNumber ? <div>{project.loanNumber}</div> : (
      <div className="alert alert-secondary text-small py-2">no loan number assigned</div>
    )}

    {!project.loanNumber && project.appId ? <button className="btn btn-primary btn-sm" disabled={loading} onClick={() => {
      setLoading(true)
      api.post(`/loanapps/${project.id}/assign-loan-number`).then(res => {
        onChange(new StatusData(res))
      }).catch(ex => {
        setLoading(false)
        toast.error(errorToString(ex))
      }).finally(() => setLoading(false))
    }}>{loading ? <Spinner /> : 'Assign Loan Number'}</button> : null}
  </div>
}

export default LoanNumber